<template>
    <el-dialog v-dragDialog title="呼吸训练日志" :visible="formVisible" width="1100px" :close-on-click-modal="false"
        :append-to-body="true" @close="close">
        <el-form>
            <el-form-item label="训练完成情况">
                {{ format.completeLevelsFormat(response.CompleteLevel) }}
            </el-form-item>
            <el-form-item label="训练后疲劳程度">
                {{format.fatigueLevelsFormat(response.FatigueLevel) }}
            </el-form-item>
            <el-form-item label="训练时呼吸器实际气压">
                {{ response.CMH2O }}
            </el-form-item>
            <el-form-item label="训练总时长">
                {{ response.Minutes }}分钟
            </el-form-item>
            <el-form-item label="本次训练动作数量">
                {{ response.CompleteTotal }}个
            </el-form-item>
            <el-form-item label="训练后是否感到获得提升">
                {{ format.improveFeelsFormat(response.ImproveFeel) }}
            </el-form-item>
            <el-form-item label="练中是否有较难完成的动作">
                {{ response.Difficults }}
            </el-form-item>
            <el-form-item label="训练中是否有存在困惑的动作">
                {{ response.Confusions }}
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            formVisible: false,
            response: "",
        };
    },
    methods: {
        show(row) {
            this.response = row;
            this.formVisible = true;
        },
        close() {
            this.formVisible = false;
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__body {
    padding: 10px 20px 20px 20px;
}
</style>